export default __webpack_public_path__ + "static/media/laboratory.857aa6ce.jpeg";